export default {
    seltec: {
        perfUrl: 'https://dlvbl.laportal.net/Performances?performanceList=',
    },
};
